import React, { Component } from 'react';
import styles from './Comment.module.css';
import PropTypes from 'prop-types';
import ReactMarkDown from 'react-markdown';
import moment from 'moment';

export default class Comment extends Component {
  state = {
    comments: [],
    files: [],
  };
  static contextTypes = {
    router: PropTypes.object,
  };

  postComment = () => {
    const { createComment, catogary, user } = this.props;
    const { router } = this.context;
    const { id } = router.route.match.params;

    const { files } = this.state;
    const content = this.refs['commentBox'].value;
    if (!content && files.length === 0) return;
    const comment = {
      user: user.username,
      content: content || '',
      modelId: id,
      type: 'normal',
    };

    createComment(comment, catogary, files).then(model => {
      this.refs['commentBox'].value = '';
      const { comments } = this.state;
      this.setState({ comments, files: [] });
    });
  };

  componentDidMount() {
    const { comments } = this.props;
    this.setState({ comments });
  }

  renderSingleComment = comment => {
    return (
      <div key={comment._id} className={styles.singleCommentContainer}>
        <img
          alt={comment.user}
          className={styles.commentor}
          src="/img/avatar.png"
        />
        <div className={styles.commentContent}>
          <div className={styles.singleCommentTop}>
            <div className={styles.commentUser}>{comment.user}</div>
            <div className={styles.commentCreate}>
              {moment(comment.createdAt).fromNow()}
            </div>
          </div>
          <ReactMarkDown
            className={styles.commentMarkDown}
            source={comment.content}
            renderers={{
              image: props => <img {...props} style={{ maxWidth: '100%' }} />,
            }}
          />
        </div>
      </div>
    );
  };

  attachFile = e => {
    const file = e.target.files && e.target.files[0];
    const { files } = this.state;
    files.push(file);
    this.setState({ files });
  };

  render() {
    const { comments, files } = this.state;
    return (
      <div>
        <div className={styles.commentContainer}>
          <div className={styles.commentTitle}> Add a Comment </div>
          <textarea ref="commentBox" className={styles.commentBox} />
          {files.length !== 0 && (
            <div className={styles.attachments}>
              {files.map(file => (
                <div className={styles.singleattachment}>
                  <img
                    style={{ margin: 'auto' }}
                    width="20"
                    height="20"
                    src="/img/attach.svg"
                  />
                  {file.name} ({file.size / 1000}
                  kB)
                </div>
              ))}
            </div>
          )}
          <div className={styles.buttonContainer}>
            <button className={styles.postComment} onClick={this.postComment}>
              Post Comment
            </button>
            <button
              className={styles.attachFile}
              onClick={e => this.refs['commentFile'].click()}
            >
              {' '}
              Attach File{' '}
            </button>
            <input
              ref="commentFile"
              type="file"
              style={{ display: 'none' }}
              onChange={this.attachFile}
            />
          </div>
        </div>
        <div className={styles.commentTitle}>
          {comments.length} Comment
          {comments.length > 1 ? 's' : ''}
        </div>
        <div className={styles.commentListContainer}>
          {comments &&
            comments.map(comment => this.renderSingleComment(comment))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Comment/index.js